import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { MinimumOrderMessageProps } from './MinimumOrderMessage.types'
import { twMerge } from 'tailwind-merge'

const MinimumOrderMessage: React.FC<MinimumOrderMessageProps> = ({
  remainingBrewsToMinimum,
  inCartPage
}) => {
  const intl = useIntl()

  if (remainingBrewsToMinimum <= 0) {
    return null
  }

  const brewBoxWordSingle = intl.formatMessage({
    id: 'msp.cart.shipment.brewbox.single',
    defaultMessage: 'Tea box'
  })

  const brewBoxWordMultiple = intl.formatMessage({
    id: 'msp.cart.shipment.brewbox.multiple',
    defaultMessage: 'Tea boxes'
  })

  const brewBoxWord =
    remainingBrewsToMinimum === 1 ? brewBoxWordSingle : brewBoxWordMultiple

  const mindest = intl.formatMessage({
    id: 'msp.cart.shipment.minimum.order.term',
    defaultMessage: 'Minimum order quantity'
  })

  return (
    <div
      className={twMerge(
        'text-pineGreen text-14 leading-16 tracking-0.4',
        inCartPage
          ? 'border-t-4 border-solid border-black px-5 pb-2 pt-4 md:px-0 xl:border-0'
          : 'p-5'
      )}
    >
      <FormattedMessage
        id='msp.cart.shipment.minimum.order.quantity'
        defaultMessage='Add {quantity} {brewBoxWord} to reach {mindest}'
        values={{
          quantity: (
            <span className='font-bold'>{remainingBrewsToMinimum}</span>
          ),
          brewBoxWord: brewBoxWord,
          mindest: <span className='font-bold uppercase'>{mindest}</span>
        }}
      />
    </div>
  )
}

export default MinimumOrderMessage
